import { IDeaNumUser } from '../common';
import { filter } from 'fp-ts/lib/Array';

export const excludeUserRoles = (keys: string[]) =>
  filter<IDeaNumUser>(({ key }) => keys.indexOf(key) === -1);
